export default __webpack_public_path__ + "static/media/Anil V. Dattani.ca8fad13.jpg";